import { render, staticRenderFns } from "./RequisitesTab.vue?vue&type=template&id=eb8c1c58"
import script from "./RequisitesTab.vue?vue&type=script&lang=js"
export * from "./RequisitesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports